<template>
    <div class="promotion-content">
        <div class="left-box" v-if="showNav">
            <div class="top-box">
                <i class="iconfont">&#xe63c;</i>
                <div class="text">采购管理</div>
            </div>
            <el-menu :default-active="menuActive" mode="vertical" class="left-menu">
<!--                :to="{path:'/goods/detail', query: {g_id:good_id}}"-->
                <el-menu-item index="studentProcurementIndex">
                    <div @click="toPage('/student/procurement/index','_self')" class="nav-item">
                        <i class="iconfont">&#xe6a4;</i>
                        商品采购
                    </div>
                </el-menu-item>
                <el-menu-item index="studentProcurementGoodsManage">
                    <div @click="toPage('/student/procurement/goodsmanage','_self')"  class="nav-item">
                        <i class="iconfont">&#xe728;</i>
                        商品管理
                    </div>
                </el-menu-item>
                <el-menu-item>
                    <div @click="toPage('/student/procurement/industrymarket','_blank')"  class="nav-item nav-item-data">
                        <i class="iconfont">&#xe63c;</i>数据分析
                    </div>
                </el-menu-item>
            </el-menu>
        </div>
        <div class="main-box">
            <div class="header-box">
                <div class="time-out" v-if="isExamOrTrain">
                    <CountDown :timeObj="timeObj" />
                </div>
                <div class="header-right">
                    <div class="user-info">
                        <div class="avatar">
                            <img :src="userInfo.avatar" alt="">
                        </div>
                        <div class="user-name">{{userInfo.name}}</div>
                    </div>
                    <div class="back-btn" @click="backBtn">
                        <i class="iconfont">&#xe644;</i>返回主界面
                    </div>
                </div>
            </div>
            <div class="content-box">
                <router-view />
            </div>
        </div>
    </div>
</template>

<script>

    import { examStuExamPage } from '@/utils/apis.js'
    import CountDown from '@/components/student/CountDown.vue'
    export default {
        components: {
            CountDown
        },
        data() {
            return {
                menuActive: '',
                showNav: false,
                timeObj:{
                    begin_time:null,
                    end_time:null,
                },
                userInfo: {
                    avatar: localStorage.getItem('studentAvatar') ? localStorage.getItem('studentAvatar') : require('../../assets/images/user_img.png'),
                    name: localStorage.getItem('studentName'),
                },
                isExamOrTrain: localStorage.getItem('examId') ? localStorage.getItem('examId') : null
            }
        },
        watch: {
            $route(route) {
                let path = route.path;
                if (path==='/student/procurement/index'){
                    this.menuActive = 'studentProcurementIndex';
                    this.showNav = true;
                }else if(path==='/student/procurement/goodsmanage'){
                    this.menuActive = 'studentProcurementGoodsManage';
                    this.showNav = true;
                }else {
                    this.showNav = false;
                }
            },
        },
        created() {
            let path =this.$route.path;
            if (path==='/student/procurement/index'){
                this.menuActive = 'studentProcurementIndex';
                this.showNav = true;
            }else if(path==='/student/procurement/goodsmanage'){
                this.menuActive = 'studentProcurementGoodsManage';
                this.showNav = true;
            }else {
                this.showNav = false;
            }
            if (this.isExamOrTrain) {
                this.getExamStuExamPage()
            }
        },
        methods:{
            // 获取考试信息
            getExamStuExamPage(){
                examStuExamPage().then((res) => {
                    this.timeObj.begin_time = res.data.begin_time;
                    this.timeObj.end_time = res.data.end_time;
                }).catch((err) => {

                })
            },
            // 菜单跳转页面
            toPage(link, type) {
                if (this.$route.query.op_id){
                    let url = this.$router.resolve({
                        path: link,
                        query: {
                            op_id: this.$route.query.op_id,
                            course_id: this.$route.query.course_id,
                            exam_module_id: this.$route.query.exam_module_id,
                        }
                    })
                    window.open(url.href, type);
                }else {
                    let url = this.$router.resolve({
                        path: link,
                        query: {
                            exam_module_id: this.$route.query.exam_module_id,
                        }
                    })
                    window.open(url.href, type);
                }
            },
            // 返回主界面
            backBtn() {
                if (this.isExamOrTrain) {
                    this.$router.push('/student/exam/onlineTradeManage/index')
                } else {
                    this.$router.push('/student/trainCenter/practice')
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .promotion-content {
        width: 100vw;
        height: 100vh;
        display: flex;
    }
    .left-box {
        width: 280px;
        background: #2C405F;
        height: 100%;
        .top-box {
            color: #fff;
            text-align: center;
            margin-top: 36px;
            .iconfont {
                display: inline-block;
                width: 60px;
                height: 60px;
                line-height: 60px;
                background: #FD4446;
                border-radius: 6px;
                font-size: 33px;
            }
            .text {
                margin-top: 22px;
                font-size: 28px;
                line-height: 1;
                font-weight: 500;
            }
        }
        .left-menu {
            margin-top: 50px;
            background-color: transparent;
            border-right: 0;
            .el-menu-item {
                height: 60px;
                line-height: 60px;
                padding: 0!important;
                .nav-item {
                    height: 100%;
                    color: #fff;
                    font-size: 20px;
                    display: flex;
                    align-items: center;
                    .iconfont {
                        color: #fff;
                        font-size: 20px;
                        margin: 0 20px 0 40px;
                    }
                }
                &:focus, &:hover {
                    background-color: #25354F;
                    .nav-item {
                        color: #fff;
                        .iconfont {
                            color: #fff;
                        }
                    }
                }
                &.is-active {
                    background: #25354F;
                    .nav-item {
                        color: #fff;
                        &:before {
                            content: '';
                            width: 2px;
                            height: 100%;
                            position: absolute;
                            top: 0;
                            left: 0;
                            background: #FD4446;
                        }
                        .iconfont {
                            color: #fff;
                        }
                    }
                }
                .nav-item-data {
                    background: #2C405F;
                }
                &.is-active {
                    .nav-item-data {
                        &:before {
                            background: #2C405F;
                        }
                    }
                }
            }
        }
    }
    .main-box {
        width: 1%;
        flex: 1;
        background: #F7F9FB;
        height: 100%;
        display: flex;
        flex-direction: column;
        .header-box {
            height: 79px;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            border-bottom: 1px solid #D1D2DB;
            position: relative;
            .time-out {
                .count-down {
                    color: #FD4446;
                }
            }
            .header-right {
                position: absolute;
                right: 30px;
                display: flex;
                align-items: center;
                font-size: 16px;
                .user-info {
                    display: flex;
                    align-items: center;
                    .avatar {
                        width: 40px;
                        height: 40px;
                        overflow: hidden;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 50%;
                        margin-right: 10px;
                        img {
                            max-width: 100%;
                        }
                    }
                }
                .back-btn {
                    margin-left: 30px;
                    cursor: pointer;
                    transition: all .3s;
                    .iconfont {
                        margin-right: 10px;
                    }
                    &:hover {
                        color: #1122D8;
                    }
                }
            }
        }
        .content-box {
            height: 1%;
            flex: 1;
        }
    }
</style>